export const CONGNO_NV_LIST_INITING = 'CONGNO_NV_LIST_INITING'
export const CONGNO_NV_LIST_REQUESTING = 'CONGNO_NV_LIST_REQUESTING'
export const CONGNO_NV_LIST_SUCCESS = 'CONGNO_NV_LIST_SUCCESS'
export const CONGNO_NV_LIST_ERROR = 'CONGNO_NV_LIST_ERROR'

export const CONGNO_NV_DVHC_LIST_REQUESTING = 'CONGNO_NV_DVHC_LIST_REQUESTING'
export const CONGNO_NV_DVHC_LIST_SUCCESS = 'CONGNO_NV_DVHC_LIST_SUCCESS'
export const CONGNO_NV_DVHC_LIST_ERROR = 'CONGNO_NV_DVHC_LIST_ERROR'

export const CONGNO_NV_NVKD_LIST_REQUESTING = 'CONGNO_NV_NVKD_LIST_REQUESTING'
export const CONGNO_NV_NVKD_LIST_SUCCESS = 'CONGNO_NV_NVKD_LIST_SUCCESS'
export const CONGNO_NV_NVKD_LIST_ERROR = 'CONGNO_NV_NVKD_LIST_ERROR'

export const CONGNO_NV_EXPORT_XLS_REQUESTING = 'CONGNO_NV_EXPORT_XLS_REQUESTING'
export const CONGNO_NV_EXPORT_XLS_SUCCESS = 'CONGNO_NV_EXPORT_XLS_SUCCESS'
export const CONGNO_NV_EXPORT_XLS_ERROR = 'CONGNO_NV_EXPORT_XLS_ERROR'

export const CONGNO_NV_UPDATE_REQUESTING = 'CONGNO_NV_UPDATE_REQUESTING'
export const CONGNO_NV_UPDATE_SUCCESS = 'CONGNO_NV_UPDATE_SUCCESS'
export const CONGNO_NV_UPDATE_ERROR = 'CONGNO_NV_UPDATE_ERROR'

export const CONGNO_NV_LIST_API = '/api/v1/congno/congno_nv_list_by_store'
export const CONGNO_NV_EXPORT_XLS_API = '/api/v1/congno/export_congno_nv_list_by_store'
export const CONGNO_NV_DVHC_LIST_API = '/api/v1/management/dvhc_get_list'
export const CONGNO_NV_NVKD_LIST_API = '/api/v1/congno/congno_list_nvkd' 
export const CONGNO_NV_UPDATE_API = '/api/v1/congno/congno_nv_update_thanhtoan'



// WEBPACK FOOTER //
// ./src/views/CongNoNhanVien/constants.js